import { NgModule } from '@angular/core';
import { ReferenceDataAccessModule } from '@reference/data-access';
import { ReferenceFeatureModule } from '@reference/feature';
import { ReferenceUiModule } from '@sdvor/reference/ui';

@NgModule({
  imports: [ReferenceDataAccessModule, ReferenceFeatureModule, ReferenceUiModule],
})
export class SdvorReferenceShellModule {}
